import { useState } from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';
import fetchDeviceList from '../../utils/fetchDeviceList';
import fetchStreamList from '../../utils/fetchStreamList';
import SingleSelector from '../single-selector/singleSelector';

export default function ReplaceCamera() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [camera1, setCamera1] = useState(null);
  const [camera2, setCamera2] = useState(null);
  const cameraList = useSelector((state) => state.app.cameraList);

  const replaceCameraApi = () => {
    const jsonData = {
      sensorId: camera2.sensorId,
    };
    axiosInstance
      .post(`${window.location.protocol}//${camera1.host}/api/v1/sensor/${camera1.sensorId}/replace`, jsonData)
      .then(async () => {
        enqueueSnackbar(`Success - replace camera ${camera1.name} by  ${camera2.name}`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        const cameraList = await fetchDeviceList(camera1.host);
        if (cameraList != null) {
          for (let i = 0; i < cameraList.length; i += 1) {
            cameraList[i].host = camera1.host;
          }
          dispatch(appSliceActions.addDevice(cameraList));
        }
        const streamList = await fetchStreamList(camera1.host);
        if (streamList != null) {
          for (let i = 0; i < streamList.length; i += 1) {
            streamList[i].host = camera1.host;
          }
          dispatch(appSliceActions.addStream(streamList));
        }
      })
      .catch((error) => {
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  const handleSubmit = () => {
    enqueueSnackbar(`Pending - replace camera`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    if (!camera1 || !camera2) {
      enqueueSnackbar(`Error - Please select cameras from both dropdowns`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    if (camera1.host !== camera2.host) {
      enqueueSnackbar(`Error - Both cameras should be from same VST device`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    replaceCameraApi();
  };

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Replace
        </Typography>
        <SingleSelector
          id="replace-cameras1"
          placeholder="Type to search"
          label="Select camera"
          value={camera1}
          onChange={setCamera1}
          getOptionLabel={(option) => {
            if (option.remoteDeviceName && option.remoteDeviceLocation) {
              return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
            } if (option.remoteDeviceName) {
              return `${option.name} at ${option.remoteDeviceName}`;
            }
            return option.name;

          }}
          options={cameraList}
        />
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          By
        </Typography>
        <SingleSelector
          id="replace-cameras2"
          placeholder="Type to search"
          label="Select camera"
          value={camera2}
          onChange={setCamera2}
          getOptionLabel={(option) => {
            if (option.remoteDeviceName && option.remoteDeviceLocation) {
              return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
            } if (option.remoteDeviceName) {
              return `${option.name} at ${option.remoteDeviceName}`;
            }
            return option.name;

          }}
          options={cameraList}
        />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
          Replace
        </LoadingButton>
      </Box>
    </>
  );
}
